export const bwColor = '#8e6767';

export const theme = {
  designColorSimple: '#8e6767',
  designColor: '#f45656',
  designColor2: '#dbd1c8',
  personalityColor: '#000000',
  highlightColor: '#002bff',
  personalityColor2: '#c0c0c0',
  highlightColorInactive: '#fcfcfc',
  highlightDimmed: '#c0c0c0',
  openColor: '#FFF',
  openColorBleak: '#EFEFEF', //не выделенный неактивированный центр, когда есть выделенные центры
  openColor2: '#d7d7d743',
  authorityColor: 'black',
  definedColor: bwColor,
  definedColorBleak: '#cfcfcf', //не выделенный центр, когда есть выделенные центры

  personalityColorC0: '#4a4a4a',
  designColorC0: '#747474',
  lineOpenC0: '#e9e9e9',

  personalityColorC1: '#00a000',
  designColorC1: '#24c424',
  lineOpenC1: '#ffffff56',

  personalityColorC2: '#005ec3',
  designColorC2: '#499df8',
  lineOpenC2: '#ffffff56',

  lineOpen: '#FFF',
  personalityColoroth: 'blue',
  line0: '#FFF',
  line0comp: 'transparent',
  highlightedGateInnerColor: '#002bff',
  highlightedGateColor: '#002bff',
  // ...colorThemeInner
}

const colorsClassic = {
  HD: '#fff9a2',
  AA: '#397944',
  TT: '#6C4B2C',
  GC: '#FEF471',
  HT: '#A7302C',
  SN: '#6C4B2C',
  SP: '#6C4B2C',
  SL: '#A7302C',
  RT: '#6C4B2C',
}
const colorsClassicBleak = {
  HD: '#FFFDE3',
  AA: '#9DCAA5',
  TT: '#C6B5A4',
  GC: '#FFFDE3',
  HT: '#f5c5c3',
  SN: '#C6B5A4',
  SP: '#C6B5A4',
  SL: '#f5c5c3',
  RT: '#C6B5A4',
}


export const linesBw = {
  base: {
    prs: theme.personalityColor,
    des: theme.designColorSimple,
    open: theme.lineOpen,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
  composite0: {
    prs: theme.personalityColorC0,
    des: theme.designColorC0,
    open: theme.lineOpenC0,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
  composite1: {
    prs: theme.personalityColorC1,
    des: theme.designColorC1,
    open: theme.lineOpenC1,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
  composite2: {
    prs: theme.personalityColorC2,
    des: theme.designColorC2,
    open: theme.lineOpenC2,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
}


export const linesClassic = {
  base: {
    prs: theme.personalityColor,
    des: theme.designColor,
    open: theme.lineOpen,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
  composite0: {
    prs: theme.personalityColorC0,
    des: theme.designColorC0,
    open: theme.lineOpenC0,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
  composite1: {
    prs: theme.personalityColorC1,
    des: theme.designColorC1,
    open: theme.lineOpenC1,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
  composite2: {
    prs: theme.personalityColorC2,
    des: theme.designColorC2,
    open: theme.lineOpenC2,
    chakraOpen: theme.openColor,
    chakraDefined: theme.definedColor,
  },
}

export const colors = {
  bw: {
    chakraHDopen: theme.openColor,
    chakraHDopenBleak: theme.openColorBleak,
    chakraHDdefined: theme.definedColor,
    chakraHDdefinedBleak: theme.definedColorBleak,
    chakraAAopen: theme.openColor,
    chakraAAopenBleak: theme.openColorBleak,
    chakraAAdefined: theme.definedColor,
    chakraAAdefinedBleak: theme.definedColorBleak,
    chakraTTopen: theme.openColor,
    chakraTTopenBleak: theme.openColorBleak,
    chakraTTdefined: theme.definedColor,
    chakraTTdefinedBleak: theme.definedColorBleak,
    chakraGCopen: theme.openColor,
    chakraGCopenBleak: theme.openColorBleak,
    chakraGCdefined: theme.definedColor,
    chakraGCdefinedBleak: theme.definedColorBleak,
    chakraHTopen: theme.openColor,
    chakraHTopenBleak: theme.openColorBleak,
    chakraHTdefined: theme.definedColor,
    chakraHTdefinedBleak: theme.definedColorBleak,
    chakraSLopen: theme.openColor,
    chakraSLopenBleak: theme.openColorBleak,
    chakraSLdefined: theme.definedColor,
    chakraSLdefinedBleak: theme.definedColorBleak,
    chakraSPopen: theme.openColor,
    chakraSPopenBleak: theme.openColorBleak,
    chakraSPdefined: theme.definedColor,
    chakraSPdefinedBleak: theme.definedColorBleak,
    chakraSNopen: theme.openColor,
    chakraSNopenBleak: theme.openColorBleak,
    chakraSNdefined: theme.definedColor,
    chakraSNdefinedBleak: theme.definedColorBleak,
    chakraRTopen: theme.openColor,
    chakraRTopenBleak: theme.openColorBleak,
    chakraRTdefined: theme.definedColor,
    chakraRTdefinedBleak: theme.definedColorBleak,

    ...linesBw

  },
  colorsClassic: {
    chakraHDopen: theme.openColor,
    chakraHDopenBleak: theme.openColorBleak,
    chakraHDdefined: colorsClassic.HD,
    chakraHDdefinedBleak: colorsClassicBleak.HD,
    chakraAAopen: theme.openColor,
    chakraAAopenBleak: theme.openColorBleak,
    chakraAAdefined: colorsClassic.AA,
    chakraAAdefinedBleak: colorsClassicBleak.AA,
    chakraTTopen: theme.openColor,
    chakraTTopenBleak: theme.openColorBleak,
    chakraTTdefined: colorsClassic.TT,
    chakraTTdefinedBleak: colorsClassicBleak.TT,
    chakraGCopen: theme.openColor,
    chakraGCopenBleak: theme.openColorBleak,
    chakraGCdefined: colorsClassic.GC,
    chakraGCdefinedBleak: colorsClassicBleak.GC,
    chakraHTopen: theme.openColor,
    chakraHTopenBleak: theme.openColorBleak,
    chakraHTdefined: colorsClassic.HT,
    chakraHTdefinedBleak: colorsClassicBleak.HT,
    chakraSLopen: theme.openColor,
    chakraSLopenBleak: theme.openColorBleak,
    chakraSLdefined: colorsClassic.SL,
    chakraSLdefinedBleak: colorsClassicBleak.SL,
    chakraSPopen: theme.openColor,
    chakraSPopenBleak: theme.openColorBleak,
    chakraSPdefined: colorsClassic.SP,
    chakraSPdefinedBleak: colorsClassicBleak.SP,
    chakraSNopen: theme.openColor,
    chakraSNopenBleak: theme.openColorBleak,
    chakraSNdefined: colorsClassic.SN,
    chakraSNdefinedBleak: colorsClassicBleak.SN,
    chakraRTopen: theme.openColor,
    chakraRTopenBleak: theme.openColorBleak,
    chakraRTdefined: colorsClassic.RT,
    chakraRTdefinedBleak: colorsClassicBleak.RT,

    ...linesClassic

  },
  colorsModern: {
    chakraHDopen: theme.openColor,
    chakraHDopenBleak: theme.openColorBleak,
    chakraHDdefined: theme.definedColor,
    chakraAAopen: theme.openColor,
    chakraAAopenBleak: theme.openColorBleak,
    chakraAAdefined: theme.definedColor,
    chakraTTopen: theme.openColor,
    chakraTTopenBleak: theme.openColorBleak,
    chakraTTdefined: theme.definedColor,
    chakraGCopen: theme.openColor,
    chakraGCopenBleak: theme.openColorBleak,
    chakraGCdefined: theme.definedColor,
    chakraHTopen: theme.openColor,
    chakraHTopenBleak: theme.openColorBleak,
    chakraHTdefined: theme.definedColor,
    chakraSLopen: theme.openColor,
    chakraSLopenBleak: theme.openColorBleak,
    chakraSLdefined: theme.definedColor,
    chakraSPopen: theme.openColor,
    chakraSPopenBleak: theme.openColorBleak,
    chakraSPdefined: theme.definedColor,
    chakraSNopen: theme.openColor,
    chakraSNopenBleak: theme.openColorBleak,
    chakraSNdefined: theme.definedColor,
    chakraRTopen: theme.openColor,
    chakraRTopenBleak: theme.openColorBleak,
    chakraRTdefined: theme.definedColor,

    ...linesBw

  },


}





